import React from 'react'
import PropTypes from 'prop-types'
import { majorScale, Alert, Button, Pane, Paragraph } from 'evergreen-v4'

const ErrorMessage = props => {
  const { title, messaging, primaryButton } = props

  const handleButtonClick = (...args) => {
    if (primaryButton.onClick) {
      return primaryButton.onClick(props, ...args)
    }

    window.location.reload()
  }

  return (
    <Pane flex="1" marginX="auto" maxWidth={majorScale(60)}>
      <Alert
        appearance="card"
        intent="danger"
        title={title}
        marginY={majorScale(8)}
      >
        <Paragraph>{messaging}</Paragraph>
        {primaryButton && (
          <Button
            appearance="primary"
            marginTop={majorScale(1)}
            onClick={handleButtonClick}
          >
            {primaryButton.children}
          </Button>
        )}
      </Alert>
    </Pane>
  )
}

ErrorMessage.propTypes = {
  title: PropTypes.string.isRequired,
  messaging: PropTypes.node,
  primaryButton: PropTypes.shape({
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func
  })
}

export default ErrorMessage
